module.exports = __webpack_public_path__ + "static/media/icon-visa--card.93a32991.svg";